import { NominationListItem, NominationStatus, NominationWarning, NominationWarningsRequest } from 'types/efforts';
import { injectCountEndPoint, portalAPI } from './portalAPI';
import { accumulatedQueryWithFilters } from './util/endpointBuilder';

const BASE = '/v1/rankings-referee-nominations';

const APIRankingsRefereesSlice = portalAPI
    .enhanceEndpoints({ addTagTypes: ['RankingsRefereeNominations', 'RankingsRefereeNominationsCount', 'Efforts'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getRankingsRefereeNominations: accumulatedQueryWithFilters<NominationListItem>(builder, BASE, {
                providesTags: ['RankingsRefereeNominations'],
                dedupeKey: (nomination) => nomination.id,
            }),
            getRankingsRefereeNominationsCount: injectCountEndPoint(builder, BASE, 'RankingsRefereeNominationsCount'),
            updateNominationStatus: builder.mutation<void, { id: number; statusCode: NominationStatus }>({
                query: ({ id, statusCode }) => ({ url: `${BASE}/${id}`, method: 'PATCH', body: { statusCode } }),
                invalidatesTags: ['RankingsRefereeNominations', 'RankingsRefereeNominationsCount', 'Efforts'],
            }),
            getNominationWarnings: builder.query<NominationWarning[], NominationWarningsRequest>({
                query: (body) => ({ url: `${BASE}/warnings`, method: 'POST', body }),
                keepUnusedDataFor: 0,
            }),
        }),
        overrideExisting: false,
    });

export const {
    useLazyGetRankingsRefereeNominationsQuery,
    useLazyGetRankingsRefereeNominationsCountQuery,
    useGetRankingsRefereeNominationsCountQuery,
    useGetRankingsRefereeNominationsQuery,
    useUpdateNominationStatusMutation,
    useGetNominationWarningsQuery,
} = APIRankingsRefereesSlice;
